<template>
  <div class="vue-leadgen-garage-select">
      <v-select
              v-model="selectedGarage"
              @input="handleInput"
              @search="handleSearch"

              :options="garages"
              :filterable="false"
              placeholder="Zoek op postcode of plaats"
              label="name"
              :loading="loading"
      >
          <template slot="option" slot-scope="option">
              {{ option.name }} <span style="font-style: italic;">({{ option.distance | formatDistance }})</span>
          </template>

          <template #no-options="{ search, searching, loading }">
              Vul a.u.b. een geldige postcode of plaatsnaam in.
          </template>
      </v-select>

      <form v-if="formPostUrl" ref="leadgenPostForm" method="POST" :action="formPostUrl" class="mt-3">
          <input type="text" class="hidden" name="email" :value="email">
          <input type="text" class="hidden" name="quotationId" :value="quotationId">
          <input type="text" class="hidden" name="plate" :value="plate">
          <input type="text" class="hidden" name="mileage" :value="mileage">
          <input type="text" class="hidden" name="serviceName" :value="serviceName">
          <button class="btn-arrow" type="submit">Selecteer vestiging</button>
      </form>
  </div>
</template>

<script>
import garageSelect from "../mixins/garage-select";

export default {
    name: "LeadgenGarageSelect",

    mixins: [garageSelect],

    props: {
        email: {
            type: String,
            default: ''
        },
        quotationId: {
            type: String,
            default: ''
        },
        plate: {
            type: String,
            default: ''
        },
        mileage: {
            type: String,
            default: ''
        },
        serviceName: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            formPostUrl: '',
        }
    },

    created() {
        this.fetchGarages()
    },

    methods: {
        handleInput(payload) {
            if (_.isNull(payload)) {
                this.formPostUrl = '';
                return;
            }

            this.formPostUrl = `${payload.url}/afspraak-plannen`;
        }
    }
}
</script>